import React, { useContext } from "react";
import { BsPinMapFill, BsPhone, BsEnvelope, BsMap } from "react-icons/bs";
import DonateButton from "../components/Donate";
import "./ContactPage.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/Layout/Header";
import ScrollAnimation from "../components/ScrollAnimations";

// Translation object
const translations = {
  en: {
    home: "Home",
    contactUs: "Contact Us",
    address: "Address",
    address1Title: "Pradhan Seva Kendra, Shri Kshetra Dindori",
    address1Detail: `Shri Swami Samarth Seva & Spiritual Development Center
Dindori, Taluka: Dindori, District: Nashik 422202`,
    address2Title: "Akhil Bharatiya Shree Swami Samarth Gurupeeth, Trimbakeshwar",
    address2Detail: `Gat No.304/3, Behind Govt Rest House, Ring Road, 
Survey No. 315, Tal. Trimbakeshwar, Dist. Nashik, Maharashtra, India – 422212`,
    phone: "Phone",
    email: "Email",
    yourName: "Your Name",
    yourEmail: "Your Email",
    yourMobile: "Your Mobile",
    yourMessage: "Your Message",
    sendMessage: "Send Message",
    viewMap: "View on Google Maps",
  },

  mr: {
    home: "मुखपृष्ठ",
    contactUs: "संपर्क करा",
    address: "पत्ता",
    address1Title: "प्रधान सेवा केंद्र, श्री क्षेत्र दिंडोरी",
    address1Detail: `श्री स्वामी समर्थ सेवा व अध्यात्म विकास केंद्र  
दिंडोरी, ता. दिंडोरी, जि. नाशिक ४२२२०२`,
    address2Title: "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर",
    address2Detail: `गट क्र.304/3, गव्हर्नमेंट रेस्ट हाऊस मागे, रिंग रोड, 
सर्वे नं 315, ता. त्र्यंबकेश्वर, जि. नाशिक, महाराष्ट्र, भारत – ४२२२१२`,
    phone: "फोन",
    email: "ईमेल",
    yourName: "तुमचे नाव",
    yourEmail: "तुमचा ईमेल",
    yourMobile: "तुमचा मोबाईल",
    yourMessage: "तुमचा संदेश",
    sendMessage: "संदेश पाठवा",
    viewMap: "गूगल नकाशावर पहा",
  },
};

export default function ContactPage() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang] || translations["en"];

  return (
    <ScrollAnimation>
      <div className="contact-page">
        <div className="header-styled">
          <Header />
          <header className="contact-header">
            <div className="header-center">
              <div className="breadcrumb">
                <Link to="/">{t.home}</Link> &gt; <span>{t.contactUs}</span>
              </div>
              <h1>{t.contactUs}</h1>
            </div>
          </header>
        </div>

        <main className="contact-main">
          <div className="contact-info">
            {/* Address 1 - Dindori */}
            <div className="contact-card">
              <BsPinMapFill className="icon icon-address" />
              <div>
                <h4>{t.address1Title}</h4>
                <p style={{ whiteSpace: "pre-line" }}>{t.address1Detail}</p>
                <a
                  href="https://www.google.com/maps?q=Shri+Kshetra+Dindori,+Nashik,+Maharashtra+422202"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="map-link"
                >
                  <BsMap className="map-icon" /> {t.viewMap}
                </a>
              </div>
            </div>

            {/* Address 2 - Trimbakeshwar */}
            <div className="contact-card">
              <BsPinMapFill className="icon icon-address" />
              <div>
                <h4>{t.address2Title}</h4>
                <p style={{ whiteSpace: "pre-line" }}>{t.address2Detail}</p>
                 <a
                  href="https://maps.app.goo.gl/qSAes34DS82DPn1z5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="map-link"
                >
                  <BsMap className="map-icon" /> {t.viewMap}
                </a>
              </div>
            </div>

            {/* Phone */}
            <div className="contact-card">
              <BsPhone className="icon icon-phone" />
              <div>
                <h4>{t.phone}</h4>
                <p> 02557-221710 | +91 9922 420 010 </p>
              </div>
            </div>

            {/* Email */}
            <div className="contact-card">
              <BsEnvelope className="icon icon-email" />
              <div>
                <h4>{t.email}</h4>
                <p>pradhankendradindori@gmail.com</p>
              </div>
            </div>

            {/* Donate Button */}
            <div className="hospital-buttons">
              <DonateButton />
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-card">
            <form className="contact-form">
              <input type="text" placeholder={t.yourName} required />
              <input type="email" placeholder={t.yourEmail} required />
              <input type="mobile" placeholder={t.yourMobile} required />
              <textarea placeholder={t.yourMessage} rows="6" required></textarea>
              <button type="submit" className="cta-donate">
                {t.sendMessage}
              </button>
            </form>
          </div>
        </main>
      </div>
    </ScrollAnimation>
  );
}
